import type { ChatRecommendation } from '@/api';

export const COMPOSER_WELCOME =
  'Describe the app you want. Composer will fill in a brief as you talk.';

export function splitComposerRecs(recs: ChatRecommendation[]): {
  playbooks: ChatRecommendation[];
  skills: ChatRecommendation[];
} {
  const playbooks = recs.filter((r) => r.kind === 'playbook');
  const skills = recs.filter((r) => r.kind === 'skill');
  if (playbooks.length === 0 && skills.length === 0) {
    return { playbooks: [], skills: recs };
  }
  return { playbooks, skills };
}

export function playbookStudioPath(outcomeId: string): string {
  return `/compose?fork=${encodeURIComponent(outcomeId)}`;
}

export function skillsetStudioPath(): string {
  return '/compose';
}

export function composerContinuePath(prompt: string): string {
  const trimmed = prompt.trim();
  if (!trimmed) return '/composer';
  return `/composer?prompt=${encodeURIComponent(trimmed)}`;
}

export function composerAfterAuthPath(prompt: string): string {
  return composerContinuePath(prompt);
}

export function guestComposerRegisterPath(prompt: string): string {
  return `/register?next=${encodeURIComponent(composerAfterAuthPath(prompt))}`;
}

export function composerSubmitPath(prompt: string, loggedIn: boolean): string {
  const trimmed = prompt.trim();
  if (!trimmed) return loggedIn ? '/composer' : guestComposerRegisterPath('');
  return loggedIn ? composerAfterAuthPath(trimmed) : guestComposerRegisterPath(trimmed);
}

export function promptFromSearch(search: string): string {
  const raw = search.startsWith('?') ? search.slice(1) : search;
  return (new URLSearchParams(raw).get('prompt') || '').trim();
}

let queuedComposerPrompt: string | null = null;

export function takeComposerContinuePrompt(search?: string): string {
  const fromSearch = promptFromSearch(
    search ?? (typeof window === 'undefined' ? '' : window.location.search),
  );
  if (fromSearch) {
    queuedComposerPrompt = fromSearch;
    if (typeof window !== 'undefined' && promptFromSearch(window.location.search)) {
      window.history.replaceState({}, '', `${window.location.pathname}${window.location.hash || ''}`);
    }
  }
  return queuedComposerPrompt || '';
}

export function releaseComposerContinuePrompt(): void {
  queuedComposerPrompt = null;
}
